var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_1418",
    width: 11.992,
    height: 34.877,
    viewBox: "0 0 11.992 34.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#211c51}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    transform: "translate(10.902 14.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    d: "M328.561 228.716a.544.544 0 0 1-.545-.545v-19.618a.545.545 0 1 1 1.09 0v19.618a.544.544 0 0 1-.545.545z",
    className: "cls-1",
    transform: "translate(-328.016 -208.008)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    transform: "translate(5.451 17.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    d: "M248.545 273.491a.544.544 0 0 1-.545-.545V256.6a.545.545 0 1 1 1.09 0v16.345a.544.544 0 0 1-.545.546z",
    className: "cls-1",
    transform: "translate(-248 -256.056)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    transform: "translate(0 14.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    d: "M168.529 228.716a.544.544 0 0 1-.545-.545v-19.618a.545.545 0 1 1 1.09 0v19.618a.544.544 0 0 1-.545.545z",
    className: "cls-1",
    transform: "translate(-167.984 -208.008)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    transform: "translate(0 33.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    d: "M179.43 497.09h-10.9a.545.545 0 1 1 0-1.09h10.9a.545.545 0 1 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-167.984 -496)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    transform: "translate(9.811 9.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    d: "M313.645 142.005a.546.546 0 0 1-.532-.427l-1.09-4.906a.545.545 0 0 1 1.064-.236l1.09 4.906a.546.546 0 0 1-.414.65.581.581 0 0 1-.118.013z",
    className: "cls-1",
    transform: "translate(-312.01 -136.011)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    transform: "translate(0 9.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    d: "M168.524 142.007a.592.592 0 0 1-.119-.013.546.546 0 0 1-.414-.65l1.09-4.906a.545.545 0 0 1 1.064.236l-1.09 4.906a.545.545 0 0 1-.531.427z",
    className: "cls-1",
    transform: "translate(-167.978 -136.013)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    transform: "translate(9.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    d: "M312.561 10.354a.544.544 0 0 1-.545-.545V.545a.545.545 0 1 1 1.09 0v9.264a.544.544 0 0 1-.545.545z",
    className: "cls-1",
    transform: "translate(-312.016)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    transform: "translate(7.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    d: "M282.733 1.09h-2.18a.545.545 0 0 1 0-1.09h2.18a.545.545 0 0 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-280.008)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    transform: "translate(5.452 2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    d: "M248.553 43.278a.545.545 0 0 1 0-1.09 1.637 1.637 0 0 0 1.635-1.635.545.545 0 0 1 1.09 0 2.728 2.728 0 0 1-2.725 2.725z",
    className: "cls-1",
    transform: "translate(-248.008 -40.008)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    transform: "translate(7.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    d: "M280.553 3.815a.544.544 0 0 1-.545-.545V.545a.545.545 0 0 1 1.09 0V3.27a.544.544 0 0 1-.545.545z",
    className: "cls-1",
    transform: "translate(-280.008)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    transform: "translate(1.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    d: "M184.545 10.354a.544.544 0 0 1-.545-.545V.545a.545.545 0 1 1 1.09 0v9.264a.544.544 0 0 1-.545.545z",
    className: "cls-1",
    transform: "translate(-184)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    transform: "translate(1.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    d: "M186.725 1.09h-2.18a.545.545 0 0 1 0-1.09h2.18a.545.545 0 0 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-184)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    transform: "translate(3.272 2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    d: "M218.733 43.278a2.728 2.728 0 0 1-2.725-2.725.545.545 0 1 1 1.09 0 1.637 1.637 0 0 0 1.635 1.635.545.545 0 1 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-216.008 -40.008)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    transform: "translate(3.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    d: "M216.553 3.815a.544.544 0 0 1-.545-.545V.545a.545.545 0 1 1 1.09 0V3.27a.544.544 0 0 1-.545.545z",
    className: "cls-1",
    transform: "translate(-216.008)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    transform: "translate(5.465 7.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    d: "M248.756 113.106a.545.545 0 0 1-.006-1.09h.006a.545.545 0 1 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-248.208 -112.016)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    transform: "translate(5.465 11.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    d: "M248.756 177.122a.545.545 0 0 1-.006-1.09h.006a.545.545 0 1 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-248.208 -176.032)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    transform: "translate(5.465 14.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    d: "M248.756 209.13a.545.545 0 0 1-.006-1.09h.006a.545.545 0 1 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-248.208 -208.04)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    transform: "translate(1.093 9.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    d: "M193.279 137.09h-8.718a.545.545 0 1 1 0-1.09h8.718a.545.545 0 0 1 0 1.09z",
    className: "cls-1",
    transform: "translate(-184.016 -136)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverall);
export default __webpack_public_path__ + "static/media/overall.fe9266c7.svg";
export { ForwardRef as ReactComponent };